// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kxI0n","inner":"Footer_inner__ZZnSv"};